import React, { createContext, useState, useEffect } from 'react';

const TripContext = createContext({});

export const TripProvider = ({ children }) => {
  // let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState(false);
  const [permission, setPermission] = useState(false);
  const [step, setStep] = useState();
  const [isFoodWaste, setIsFoodWaste] = useState(false);
  const [selectedDestinations, setSelectedDestinations] = useState(false);
  const [tripStopsLimit, setTripStopsLimit] = useState(4);

  const setUserLocation = (position) => {
    setLocation({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
  };

  const getLocation = () =>
    navigator.geolocation.getCurrentPosition(setUserLocation, null, {
      maximumAge: 60000,
      timeout: 5000,
      enableHighAccuracy: true,
    });

  useEffect(() => {
    setLoading(true);

    if (!navigator.permissions) {
      setTimeout(() => {
        getLocation();
      });
    } else {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state === 'granted') {
          setPermission(true);
        } else if (result.state === 'prompt') {
          setPermission(false);
        }
        if (navigator.geolocation) {
          getLocation();
        } else {
          alert('Geolocation is not supported by this browser.');
        }
        setLoading(false);
      });
    }
  }, []);

  return (
    <TripContext.Provider
      value={{
        loading,
        setLoading,
        location,
        setLocation,
        step,
        setStep,
        permission,
        isFoodWaste,
        setIsFoodWaste,
        selectedDestinations,
        setSelectedDestinations,
        tripStopsLimit,
        setTripStopsLimit,
      }}
    >
      {children}
    </TripContext.Provider>
  );
};

export default TripContext;
